module.exports = __webpack_public_path__ + "img/proceso.df3b7dc4.png";